// Client-side session gate for the admin UI. Credentials are fixed for now;
// swap `login` for a real API call when backend auth lands.
const STORAGE_KEY = "voicing-auth";

const USERNAME = "admin";
const PASSWORD = "Voicing@123";

export function isAuthenticated(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function login(username: string, password: string): boolean {
  if (username.trim() === USERNAME && password === PASSWORD) {
    localStorage.setItem(STORAGE_KEY, "1");
    return true;
  }
  return false;
}

export function logout() {
  localStorage.removeItem(STORAGE_KEY);
}
